import dayjs from "dayjs";
import mime from "mime";
// src/modules/Files/utils/file-from-data-uri.ts
async function fileFromDataUri(dataURI, fileName) {
	const blob = await (await fetch(dataURI)).blob();
	const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
	const ext = mime.getExtension(mimeString) ?? ".txt";
	const name = fileName ? `${fileName}.${ext}` : `file-${dayjs().toISOString()}.${ext}`;
	return new File([blob], name, { type: mimeString });
}
export { fileFromDataUri };

//# sourceMappingURL=file-from-data-uri.js.map